import React, { Component } from "react";
import {
    Row,
    Col,
    Button
} from "reactstrap";

import Helpers from "../Utils/Helpers";
import Registry from "../Utils/Registry";

import CreateOrderRecap from "../components/CreateOrder/Recap";
import CreateOrderFormInformation from "../components/CreateOrder/Form/Information";
import CreateOrderFormVehicles from "../components/CreateOrder/Form/Vehicles";
import CreateOrderFormPayment from "../components/CreateOrder/Form/Payments";
import { NotificationManager } from "react-notifications";


class CreateOrder extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.loadGasPrices = this.loadGasPrices.bind(this);
        this.informationStepComplited = this.informationStepComplited.bind(this);
        this.vehiclesStepComplited = this.vehiclesStepComplited.bind(this);
        this.paymentStepComplited = this.paymentStepComplited.bind(this);
        this.createOrder = this.createOrder.bind(this);
        this.setStep = this.setStep.bind(this);

        this.state = {
            step: 0,
            address_checked: false,
            delivery_slot: null,
            delivery_state: null,
            vehicles_state: null,
            payment_state: null,
            location: null,
            comment: "",
            vehicles: [],
            meta_data: [],
            payment: null,
            driver_id: null,
            order_id: null,
            loading: false,
            sp_price: 0,
            gazole_price: 0,
            gnv_price: undefined,
            fee_per_vehicle: 0,
            fees_type: 0,
            business: null,
            showGasPrices: false
        };
    }

    componentDidMount(){
        let user = Registry.observe(this, "user", user => {
            this.loadBusiness(user);
        });
        if(user) {
            this.loadBusiness(user);
        }
    }

    setStep(step){
        if(this.state.step > step)
            this.setState({step: step});
    }

    loadBusiness = (user) => {
        this.api.get("/business/" + user.business_id)
            .then(res => {
                this.setState({
                    business: res.business
                }, () => {
                    if (this.state.business.account_setup === 0 || this.state.business.account_setup === 2)
                        Helpers.goTo("/")
                });
            });
    };

    loadGasPrices(address) {
        this.api.get("/business/prices?location=" + address)
            .then(results => {
                let go_price = 0;
                let sp_price = 0;
                let gnv_price = undefined;
                let fees = 0;
                let fees_type = 0;
                for(let g of results){
                    if(g.shorten === "gasole")
                        go_price = g.price_ttc;
                    else if(g.shorten === "SP98")
                        sp_price = g.price_ttc;
                    else if(g.shorten === "gnv")
                        gnv_price = g.price_ttc;
                    else if(g.product_type === "FEE"){
                        fees = g.price_ttc;
                        fees_type = parseInt(g.product_type_id);
                    }
                }
                this.setState({
                    sp_price: sp_price,
                    gazole_price: go_price,
                    gnv_price: gnv_price,
                    fee_per_vehicle: fees,
                    fees_type: fees_type
                });
            })
            .catch(error => { this.setState({showGasPrices: false}) });
    }

    informationStepComplited(location, slot, comment, state=false){
        // let driver_id = slot.drivers_id[0];

        this.setState({
            step: 1,
            delivery_slot: slot,
            location: location,
            comment: comment,
            address_checked: true,
            delivery_state: state,
            meta_data: state.meta_data
        }, () => this.loadGasPrices(location));
    }

    vehiclesStepComplited(vehicles, state=false){
        this.setState({
            step: 2,
            vehicles: vehicles,
            vehicles_state: state
        });
    }

    paymentStepComplited(payment, state=false){
        this.setState({
            step: 3,
            payment: payment,
            payment_state: state
        });
    }

    createOrder(){
        if(this.state.delivery_slot && this.state.location && this.state.payment && this.state.vehicles.length){
            this.setState({ loading: true, step: 4 });

            let meta_data = {};
            for(let m of this.state.meta_data)
                meta_data[m.label] = m.value;

            let min = new Date(this.state.delivery_slot.date);
            let max = new Date(this.state.delivery_slot.date);
            min.setHours(this.state.delivery_slot.min, 0, 0);
            max.setHours(this.state.delivery_slot.max, 0, 0);

            this.api.post("/orders", {
                is_business: 1,
                available_date_min: min.toMysqlFormat(),
                available_date_max: max.toMysqlFormat(),
                vehicles: JSON.stringify(this.state.vehicles),
                location: this.state.location,
                meta_data: JSON.stringify(meta_data),
                delivery_infos: this.state.comment,
                payment_id: this.state.payment.id
            })
                .then(results => {
                    this.setState({
                        loading: false,
                        order_id: results.order.shorten
                    });
                })
                .catch(e => {
                    this.setState({loading: false}, () => {
                        if(e.subcode && e.subcode === "POSTOrdersCardDeclined")
                            NotificationManager.error("Impossible de créer la commande car votre carte a été declinée");
                        else
                            NotificationManager.error("Impossible de créer la commande");
                    });
                });
        }
    }

    onAddressSelected = (address) => {
        this.setState({ showGasPrices: true}, () => this.loadGasPrices(address) );
    };

    displayGasPrices = (bool = false) => {
        this.setState({ showGasPrices: bool });
    };

    render(){
        let form = "";
        switch(this.state.step){
            case 1:
                form = <CreateOrderFormVehicles state={this.state.vehicles_state} onValidateStep={this.vehiclesStepComplited} />;
                break;
            case 2:
                form = <CreateOrderFormPayment state={this.state.payment_state} onValidateStep={this.paymentStepComplited} />;
                break;
            case 0:
            default:
                form = <CreateOrderFormInformation
                    state={this.state.delivery_state}
                    onValidateStep={this.informationStepComplited}
                    onAddressSelected={this.onAddressSelected}
                    displayGasPrices={this.displayGasPrices}
                />;
                break;
        }

        return (
            <div className="no-padding">
                <div className="bg-white">
                    <h1 className="ty-title">Passer commande</h1>

                    <div className="pad-l-30 bg-white marg-t-30 pad-b-10 f-14 medium blue_dark">
                        <span className={this.state.step > 0 ? "pointer pink" : ""} onClick={() => {this.setStep(0)}}>Informations livraison <i className="icon icon-chevron-right pad-l-5 pad-r-5" aria-hidden="true" /> </span>
                        <span className={this.state.step > 1 ? "pointer pink" : ""} onClick={() => {this.setStep(1)}}>V&eacute;hicule(s) <i className="icon icon-chevron-right pad-l-5 pad-r-5" aria-hidden="true" /> </span>
                        <span className={this.state.step > 2 ? "pointer pink" : ""} onClick={() => {this.setStep(2)}}>Paiement</span>
                    </div>
                </div>

                <div className="pad-30">
                    <Row>
                        {
                            this.state.step < 3 ?
                                <Col sm="12" lg="5" xs="12">
                                    { form }
                                </Col>
                                : ""
                        }
                        {
                            this.state.step < 3 ?
                                <Col lg="1" xs="0"> </Col>
                                :
                                <Col lg="2" xs="0"> </Col>
                        }
                        <Col lg={this.state.step < 3 ? 4 : 8} sm="12" xs="12">
                            {
                                this.state.loading ?
                                    <div className="center pad-20">
                                        <i className="icon icon-loading animated spin infinite f-20 blue_dark"> </i>
                                    </div>
                                    : ""
                            }

                            {
                                this.state.step > 3 && this.state.order_id ?
                                    <div className="ty-block marg-t-15">
                                        <div className="text-uppercase f-25 green bold pad-20 center">
                                            Commande soumise.<br />
                                            Merci<br />
                                            <div className="f-15">
                                                Nous reviendrons vers vous tr&egrave;s rapidement afin de confirmer la commande et vous communiquer un horaire de passage precis.
                                            </div>
                                            <div
                                                onClick={() => Helpers.goTo("/home")}
                                                className="pointer background-contain-center _h-66 _w-80 f-32 lh-66 display-inline-block"
                                                style={{backgroundImage: 'url("'+require("../../public/img/TankYou-v2.png")+'")'}}
                                            >
                                                &nbsp;
                                            </div>
                                        </div>
                                        <div className="grey_dark f-12 center">
                                            Commande n&deg; {this.state.order_id}
                                        </div>
                                        <div className="center marg-t-20">
                                            <Button className="text-uppercase" color="primary" onClick={ () => {Helpers.goTo("/home")} }>
                                                Revenir &agrave; l'accueil
                                            </Button>
                                        </div>
                                    </div>
                                    :
                                    ""
                            }

                            <CreateOrderRecap
                                deliverySlot={this.state.delivery_slot}
                                location={this.state.location}
                                vehicles={this.state.vehicles}
                                payment={this.state.payment}
                                step={this.state.step}
                                onValidateOrder={this.createOrder}
                                sp_price={this.state.sp_price}
                                gazole_price={this.state.gazole_price}
                                gnv_price={this.state.gnv_price}
                                fee_per_vehicle={this.state.fee_per_vehicle}
                                fees_type={this.state.fees_type}
                                showGasPrices={this.state.showGasPrices}
                            />
                        </Col>
                        {
                            this.state.step < 3 ?
                                null
                                :
                                <Col md="2" xs="0"> </Col>
                        }
                    </Row>
                </div>
            </div>
        );
    }
}

CreateOrder.defaultProps = {

};

export default CreateOrder;



// WEBPACK FOOTER //
// ./src/views/CreateOrder.js